import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Auth from '../auth';
import { confirmarMfaApi, loginApi, enlazarMfaUsuarioApi, getSeller } from '../api/axios'
import { setAuthenticated, setIdSeller, setUserName, setUserCredenciales, setMfaStatus } from '../actions/generalActios'
import { fetchTokenResetPassword, userTypeIds, postSearchUsuario } from '../actions/usuariosActions';
import { GoogleReCaptcha, withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { toast } from '../utilities/appToast';
import { encryptPassword } from '../utilities/encryptPassword';
import './Login.css';

// Wrapper para usar hooks en class component y el Provider de ReCaptcha

class Login extends React.Component {
    constructor(props) {
        super(props);
        //this._SolveReCaptcha = false; //process.env.NODE_ENV === "production"; //desarrollo - no olvidar el appsettings.json que apunta a desarrollo con su score
        this._SolveReCaptcha = true; //produccion - no olvidar el appsettings.json que apunta a produccion con su score
        this.loginStageRef = React.createRef();
        this._exitNavigateTimer = null;
        this.state = {
            user: '',
            email: '',
            password: '',
            errorMessage: '',
            showSpinner: false,
            recoverPassword: false,
            showPassword: false,
            mFaHabilitado: false,
            mfaConfirmado: false,
            showInputMFaHabilitado: false,
            esperandoCodigoDobleAutenticacion: false,
            codigoDobleAutenticacion: "",
            errorCodigoDobleAutenticacion: "",

            // New MFA Flow State
            showMfaPrompt: false,
            showMfaSetup: false,
            codigoQR: null,
            mfaSetupCode: "",
            mfaSetupError: "",
            loginResponseData: null,
            loginExitActive: false,
            loginExitReveal: false,
            isMobile: typeof window !== 'undefined' && window.innerWidth < 992,
            sellerLogo: "",
            sellerNombre: "",
        }
    }

    isSellerUserType = (tipoUsuario) =>
        tipoUsuario === userTypeIds.isSellerAdmin || tipoUsuario === userTypeIds.isSeller;

    extractSellerFromResponse = (res) =>
        res?.paginateSellers?.elementos?.[0] ??
        res?.PaginateSellers?.Elementos?.[0] ??
        res?.seller ??
        res?.Seller ??
        null;

    async fetchSellerBranding(idSeller, tipoUsuario, fallbackNombre = "") {
        if (!this.isSellerUserType(tipoUsuario) || !idSeller || Number(idSeller) <= 0) {
            return { sellerLogo: "", sellerNombre: "" };
        }

        try {
            const res = await getSeller(idSeller);
            const seller = this.extractSellerFromResponse(res);
            if (!seller) {
                return { sellerLogo: "", sellerNombre: fallbackNombre || "" };
            }

            const sellerLogo = seller.logo || seller.urlLogo || "";
            const sellerNombre =
                seller.nombreTienda ||
                seller.razonSocial ||
                fallbackNombre ||
                "";

            return { sellerLogo, sellerNombre };
        } catch {
            return { sellerLogo: "", sellerNombre: fallbackNombre || "" };
        }
    }

    componentWillUnmount() {
        this._mobileMedia?.removeEventListener('change', this.onMobileChange);
        if (this._exitNavigateTimer != null) {
            clearTimeout(this._exitNavigateTimer);
            this._exitNavigateTimer = null;
        }
        if (this._exitRevealTimer != null) {
            clearTimeout(this._exitRevealTimer);
            this._exitRevealTimer = null;
        }
    }

    onMobileChange = (event) => {
        this.setState({ isMobile: event.matches });
    };

    componentDidMount() {
        this.setState({ recoverPassword: false });
        this._mobileMedia = window.matchMedia('(max-width: 991px)');
        this._mobileMedia.addEventListener('change', this.onMobileChange);
        this.setState({ isMobile: this._mobileMedia.matches });
    }

    componentDidUpdate(prevProps) {
        const key = this.props.location?.key;
        if (key != null && key !== prevProps.location?.key) {
            this.setState({ recoverPassword: false });
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "codigoDobleAutenticacion") {
            const soloNumeros = value.replace(/\D/g, "");
            this.setState({ codigoDobleAutenticacion: soloNumeros });
        } else if (name === "mfaSetupCode") {
            const soloNumeros = value.replace(/\D/g, "");
            this.setState({ mfaSetupCode: soloNumeros });
        } else {
            this.setState({ [name]: value });
        }
    }

    onRequestToken = (event) => {
        if (event?.preventDefault) event.preventDefault();
        this.setState({ showSpinner: true });

        this.props.fetchTokenResetPassword(this.state.email)
            .then(() => {
                this.setState({ recoverPassword: false });
                toast.success("Se enviará un mail al correo del usuario con un token temporal para que pueda ingresar");
            })
            .catch((err) => {
                const errores = err?.response?.data?.errores || ["No pudo enviarse el token"];
                errores.forEach(error => toast.error(error));
            })
            .finally(() => {
                this.setState({ showSpinner: false });
            });
    };

    handleFormSubmit = (e) => {
        e.preventDefault();
        if (this.state.recoverPassword) {
            return;
        }
        this.onLogin(e);
    };

    extractLoginErrorMessage = (err) => {
        const data = err?.response?.data;

        if (!data) {
            return null;
        }

        // Caso backend BFF: { mensaje, detalle } donde detalle contiene "Body: { ... }"
        const detalle = data?.detalle;
        if (typeof detalle === "string") {
            const bodyMatch = detalle.match(/Body:\s*(\{.*\})\s*$/);
            if (bodyMatch?.[1]) {
                try {
                    const parsedBody = JSON.parse(bodyMatch[1]);
                    return parsedBody?.Message || parsedBody?.message || null;
                } catch (e) {
                    // Si no parsea, seguir con fallbacks
                }
            }

            return detalle;
        }

        if (typeof data?.mensaje === "string") {
            return data.mensaje;
        }

        return null;
    }

    onLogin = async (e) => {
        e.preventDefault();
        if (this.state.submitted) return;

        this.setState({ submitted: true, showSpinner: true });

        let tokenReCaptcha = "";

        if (this._SolveReCaptcha) {
            const executeRecaptcha = this.props.googleReCaptchaProps?.executeRecaptcha;
            if (!executeRecaptcha) {
                this.setState({
                    errorMessage: "El servicio de ReCaptcha no está disponible. Intente nuevamente.",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }

            try {
                tokenReCaptcha = await executeRecaptcha("login");
            } catch (error) {
                console.error("Error executing reCAPTCHA", error);
                this.setState({
                    errorMessage: "Error al validar ReCaptcha. Intente nuevamente.",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }

            if (!tokenReCaptcha) {
                this.setState({
                    errorMessage: "No se pudo obtener el token de ReCaptcha. Intente nuevamente",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }
        }

        const { user, password, codigoDobleAutenticacion } = this.state;

        let requestLogin = {
            Usuario: user,
            Password: encryptPassword(password),
            codigo: codigoDobleAutenticacion,
            idConexion: "string",
            TokenCaptcha: tokenReCaptcha
        }


        let req = loginApi(requestLogin);

        this.props.setUserCredenciales(user, encryptPassword(password))

        req.then(async (res) => {
            const { mfaHabilitado, mfaConfirmado, tipoUsuario, fechaUltimoLogin, mfaBypass } = res;

            this.props.setMfaStatus(mfaHabilitado, mfaConfirmado, this.state.codigoDobleAutenticacion);



            // Si es un usuario que debe resetear password (tipo 5)
            if (tipoUsuario == userTypeIds.isResetPassword) {

                this.completeLogin(res);
                return;
            }

            // Bypass MFA: solo si el BFF marca mfaBypass (SecurityOverrides:MfaBypassUserIds en appsettings)
            if (mfaBypass) {
                this.completeLogin(res);
                return;
            }

            if ((mfaHabilitado === false && mfaConfirmado === false) ||
                (mfaHabilitado === true && mfaConfirmado === false)) {

                // Interceptar inicio de sesión si MFA no está habilitado/confirmado
                this.setState({
                    loginResponseData: res,
                    showMfaPrompt: true,
                    submitted: false,
                    showSpinner: false
                });

            } else if (mfaHabilitado === true && mfaConfirmado === true) {
                this.setState({
                    submitted: false,
                    esperandoCodigoDobleAutenticacion: true,
                    showInputMFaHabilitado: true,
                    showSpinner: false,
                });

                if (this.state.codigoDobleAutenticacion.length === 6) {
                    this.completeLogin(res);
                }
            }


        }).catch(err => {
            let errorMsg = "Error de autenticación";


            if (err?.response?.status === 400 && this.state.esperandoCodigoDobleAutenticacion) {
                errorMsg = "El código de segundo factor de autenticación es inválido";
                this.setState({
                    errorMessage: "",
                    errorCodigoDobleAutenticacion: errorMsg,
                    submitted: false,
                    showSpinner: false,
                    codigoDobleAutenticacion: "",
                });
            } else {
                // Manejo de otros errores
                // Si la API devuelve un array de errores directamente
                if (Array.isArray(err?.response?.data)) {
                    err.response.data.forEach(error => toast.error(error));
                    this.setState({
                        errorMessage: "",
                        submitted: false,
                        showSpinner: false,
                    });
                    return;
                }
                // Errores del backend como array de strings en propiedad 'errores'
                if (err?.response?.data?.errores) {
                    const errores = err.response.data.errores;
                    errores.forEach(error => toast.error(error));
                    this.setState({
                        errorMessage: "",
                        submitted: false,
                        showSpinner: false,
                    });
                    return;
                }

                this.setState({
                    errorMessage: "",
                    submitted: false,
                    showSpinner: false,
                });

                const backendErrorMessage = this.extractLoginErrorMessage(err);
                toast.error(backendErrorMessage || errorMsg);
            }


        });
    }

    completeLogin = async (res) => {
        const { idSeller, nombre, tipoUsuario, userId, hiddenItemsIds, fechaUltimoLogin, mfaConfirmado, mfaHabilitado, canImpersonate } = res;
        let { codProv } = res;

        // Se detecta usuario en proceso de reset si:
        // 1. Es un usuario existente (fechaUltimoLogin).
        // 2. Tiene MFA Confirmado en FALSE.
        // 3. Tiene MFA Habilitado en FALSE (esto lo distingue de usuarios normales pendientes de configurar MFA).
        const isUsuarioExistenteConResetPendiente = mfaHabilitado === false && mfaConfirmado === false && fechaUltimoLogin;

        const isResetPassword = tipoUsuario == userTypeIds.isResetPassword;

        // ID efectivo del usuario — puede ser 0 si el login API no lo devuelve correctamente (ej. Contaduria tipo 8)
        let effectiveUserId = userId;

        // Si estamos en modo reset y el userId vino como 0/vacío, buscar el ID real por username
        if (isResetPassword && (!effectiveUserId || effectiveUserId === 0)) {
            try {
                const userResponse = await postSearchUsuario({ nombreUsuario: this.state.user || this.state.email });
                const usuarios = userResponse?.data?.usuario ?? userResponse?.data?.Usuario ?? userResponse?.usuario ?? userResponse?.Usuario ?? [];
                if (Array.isArray(usuarios) && usuarios.length > 0) {
                    effectiveUserId = usuarios[0].idUsuario || usuarios[0].IdUsuario || 0;
                }
            } catch (error) {
                // Si falla la búsqueda, continuar con userId=0 y dejar que UserEdit maneje el fallback
            }
        }

        const redirectTo = isResetPassword
            ? `/Usuarios/Editar/${effectiveUserId}`
            : `/`;

        // Si codProv no vino en el login, lo buscamos en el detalle del usuario
        if (!codProv && tipoUsuario !== userTypeIds.isResetPassword) {
            try {
                // Se busca por nombreUsuario como solicitó el usuario
                const userResponse = await postSearchUsuario({ nombreUsuario: this.state.user });
                const usuarios = userResponse?.data?.usuario ?? userResponse?.data?.Usuario ?? userResponse?.usuario ?? userResponse?.Usuario ?? [];
                if (Array.isArray(usuarios) && usuarios.length > 0) {
                    const userObj = usuarios[0];
                    // Intenta con idProveedor/idProvedor en camel o pascal.
                    codProv = userObj.idProveedor || userObj.IdProveedor || userObj.idProvedor || userObj.IdProvedor;
                }
            } catch (error) {
                // Silently handle error
            }
        }

        const userName = res.nombreUsuario || res.nombre || this.state.user || this.state.email || "";
        Auth.login(idSeller, userName, tipoUsuario, effectiveUserId, hiddenItemsIds, codProv, null, canImpersonate);

        const sellerBranding = await this.fetchSellerBranding(idSeller, tipoUsuario, nombre);
        this.setState({
            submitted: false,
            showSpinner: false,
            sellerLogo: sellerBranding.sellerLogo,
            sellerNombre: sellerBranding.sellerNombre,
        });

        const runNavigate = () => {
            if (this._exitNavigateTimer != null) {
                clearTimeout(this._exitNavigateTimer);
                this._exitNavigateTimer = null;
            }
            if (isResetPassword) {
                this.props.navigate(redirectTo, {
                    state: {
                        isResetMode: true,
                        resetToken: this.state.password,
                        username: this.state.user || this.state.email // Pass the input user/email
                    }
                });
            } else {
                this.props.navigate(redirectTo);
            }
        };

        if (isResetPassword) {
            runNavigate();
            return;
        }

        const reduceMotion =
            typeof window !== 'undefined' &&
            window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reduceMotion) {
            runNavigate();
            return;
        }

        const SWALLOW_MS = 1150;
        const REVEAL_MS = 950;

        this.setState({ loginExitActive: true, loginExitReveal: false }, () => {
            this._exitRevealTimer = window.setTimeout(() => {
                this.setState({ loginExitReveal: true });
            }, SWALLOW_MS);

            this._exitNavigateTimer = window.setTimeout(() => {
                if (this._exitRevealTimer != null) {
                    clearTimeout(this._exitRevealTimer);
                    this._exitRevealTimer = null;
                }
                runNavigate();
            }, SWALLOW_MS + REVEAL_MS);
        });
    }

    handleStartMfaSetup = () => {
        this.setState({ showSpinner: true });
        const { userId } = this.state.loginResponseData;
        const { user, password } = this.state;

        let requestEnlazarMfa = {
            idUsuario: userId,
            usuario: user,
            password: encryptPassword(password)
        };

        enlazarMfaUsuarioApi(requestEnlazarMfa)
            .then((res) => {
                this.setState({
                    codigoQR: res.codigoQrEnlace,
                    showMfaSetup: true,
                    showMfaPrompt: false,
                    showSpinner: false
                });
            })
            .catch(err => {
                toast.error("Error al iniciar configuración MFA");
                this.setState({ showSpinner: false });
            });
    }

    handleConfirmMfaSetup = () => {
        const { userId } = this.state.loginResponseData;
        const { mfaSetupCode } = this.state;

        if (!mfaSetupCode || mfaSetupCode.length !== 6) {
            this.setState({ mfaSetupError: "El código debe tener 6 dígitos" });
            return;
        }

        const requestConfirmarMfa = {
            idUsuario: userId,
            codigo: mfaSetupCode,
        };

        this.setState({ showSpinner: true, mfaSetupError: "" });

        confirmarMfaApi(requestConfirmarMfa)
            .then(() => {
                toast.success("MFA configurado correctamente");
                this.props.setMfaStatus(true, true);
                this.completeLogin(this.state.loginResponseData);
            })
            .catch((error) => {
                this.setState({
                    showSpinner: false,
                    mfaSetupError: "Código incorrecto. Intente nuevamente."
                });
            });
    }

    togglePasswordVisibility = () => {
        if (this.state.password.length === 0) {
            toast.warn("Ingrese contraseña");
            return;
        }
        this.setState(prevState => ({ showPassword: !prevState.showPassword }));
    };

    handleVerifyReCaptcha = (token) => {
        if (this.state.setTokenReCaptcha) {
            this.verifyReCaptcha(token);
        }
    }

    renderMobileLogin() {
        const {
            showSpinner,
            recoverPassword,
            showInputMFaHabilitado,
            codigoDobleAutenticacion,
            showMfaPrompt,
            showMfaSetup,
            codigoQR,
            mfaSetupCode,
            mfaSetupError,
            loginExitActive,
        } = this.state;

        const title = recoverPassword
            ? 'Recuperar contraseña'
            : showMfaSetup
                ? 'Vincular autenticador'
                : showMfaPrompt
                    ? 'Doble factor'
                    : showInputMFaHabilitado
                        ? 'Código de verificación'
                        : 'Ingresar';

        return (
            <section className={`login-app${loginExitActive ? ' login-app--exit' : ''}`}>
                <header className="login-app__header">
                    <div className="login-app__brand">
                        <span className="login-app__mark" aria-hidden="true">
                            <img src="/img/logo-mega-m.svg" alt="" />
                        </span>
                        <span className="login-app__wordmark">
                            <span className="login-app__wordmark-kicker">Megatone</span>
                            Marketplace
                        </span>
                    </div>
                </header>
                <h1 className="login-app__title">{title}</h1>
                <form className="login-app__form" onSubmit={this.handleFormSubmit} autoComplete="on" noValidate>
                    {recoverPassword ? (
                        <>
                            <label className="login-app__label" htmlFor="login-app-email">Email</label>
                            <input
                                id="login-app-email"
                                key="login-app-email"
                                name="email"
                                type="email"
                                className="login-app__input"
                                placeholder="Email del usuario"
                                autoComplete="email"
                                onChange={this.handleChange}
                                value={this.state.email}
                            />
                            {showSpinner ? (
                                <div className="login-app__loading" aria-live="polite">
                                    <span className="login-app__spinner" />
                                    <p className="login-app__status">Enviando…</p>
                                </div>
                            ) : (
                                <button type="button" className="login-app__submit" onClick={this.onRequestToken}>
                                    Enviar
                                </button>
                            )}
                            <button
                                type="button"
                                className="login-app__link"
                                onClick={() => this.setState({ recoverPassword: false })}
                            >
                                Volver al ingreso
                            </button>
                        </>
                    ) : showMfaPrompt ? (
                        <>
                            <p className="login-app__text">Activá el doble factor para proteger tu cuenta.</p>
                            <button type="button" className="login-app__submit" onClick={this.handleStartMfaSetup}>
                                Configurar ahora
                            </button>
                            <a className="login-app__link" href="/manual_mfa.html" target="_blank" rel="noopener noreferrer">
                                Ayuda para configurar
                            </a>
                        </>
                    ) : showMfaSetup ? (
                        <>
                            {codigoQR ? (
                                <img
                                    className="login-app__qr"
                                    src={`data:image/png;base64,${codigoQR}`}
                                    alt="QR de autenticación"
                                />
                            ) : null}
                            <label className="login-app__label" htmlFor="login-app-mfa-setup">Código</label>
                            <input
                                id="login-app-mfa-setup"
                                name="mfaSetupCode"
                                type="text"
                                inputMode="numeric"
                                className="login-app__input"
                                placeholder="Código de 6 dígitos"
                                maxLength={6}
                                onChange={this.handleChange}
                                value={mfaSetupCode}
                            />
                            {mfaSetupError ? <p className="login-app__error">{mfaSetupError}</p> : null}
                            <button type="button" className="login-app__submit" onClick={this.handleConfirmMfaSetup}>
                                Confirmar
                            </button>
                            <button
                                type="button"
                                className="login-app__link"
                                onClick={() => this.setState({ showMfaSetup: false, showMfaPrompt: true })}
                            >
                                Cancelar
                            </button>
                        </>
                    ) : (
                        <>
                            <label className="login-app__label" htmlFor="login-app-user">Usuario</label>
                            <input
                                id="login-app-user"
                                name="user"
                                type="text"
                                className="login-app__input"
                                placeholder="Usuario"
                                autoComplete="username"
                                onChange={this.handleChange}
                                value={this.state.user}
                            />
                            <label className="login-app__label" htmlFor="login-app-password">Contraseña</label>
                            <div className="login-app__password">
                                <input
                                    id="login-app-password"
                                    name="password"
                                    type={this.state.showPassword ? 'text' : 'password'}
                                    className="login-app__input"
                                    placeholder="Contraseña"
                                    autoComplete="current-password"
                                    onChange={this.handleChange}
                                    value={this.state.password}
                                />
                                <button
                                    type="button"
                                    className="login-app__password-toggle"
                                    onClick={this.togglePasswordVisibility}
                                    aria-label={this.state.showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                >
                                    <i className={`mdi mdi-eye${this.state.showPassword ? '' : '-off'}`} />
                                </button>
                            </div>
                            {showInputMFaHabilitado ? (
                                <>
                                    <label className="login-app__label" htmlFor="login-app-mfa">Código</label>
                                    <input
                                        id="login-app-mfa"
                                        name="codigoDobleAutenticacion"
                                        type="text"
                                        inputMode="numeric"
                                        className="login-app__input"
                                        placeholder="Código de 6 dígitos"
                                        maxLength={6}
                                        onChange={this.handleChange}
                                        value={codigoDobleAutenticacion}
                                    />
                                </>
                            ) : null}
                            {this.state.errorMessage ? <p className="login-app__error">{this.state.errorMessage}</p> : null}
                            {this._SolveReCaptcha && Boolean(this.props.googleReCaptchaProps?.executeRecaptcha) ? (
                                <GoogleReCaptcha onVerify={this.handleVerifyReCaptcha} />
                            ) : null}
                            <button type="submit" className="login-app__submit" onClick={this.onLogin} disabled={showSpinner}>
                                {showSpinner ? (
                                    <span className="login-app__loading" aria-live="polite">
                                        <span className="login-app__spinner" />
                                        Ingresando…
                                    </span>
                                ) : 'Entrar'}
                            </button>
                            <button
                                type="button"
                                className="login-app__link"
                                onClick={() => this.setState({ recoverPassword: true })}
                            >
                                Recuperar contraseña
                            </button>
                        </>
                    )}
                </form>
            </section>
        );
    }

    render() {
        const { showSpinner, recoverPassword, showInputMFaHabilitado, codigoDobleAutenticacion, showMfaPrompt, showMfaSetup, codigoQR, mfaSetupCode, mfaSetupError, loginExitActive, loginExitReveal, sellerLogo, sellerNombre, isMobile } = this.state;
        if (isMobile) {
            return this.renderMobileLogin();
        }
        const hasSellerBranding = Boolean(sellerNombre);

        const IconEye = (isHidden) => (
            <i className={`mdi mdi-eye${isHidden ? "" : "-off"} mdi-24px`} />
        );

        const screenClass = [
            'login-screen',
            loginExitActive ? 'login-screen--exit' : '',
            loginExitReveal ? 'login-screen--reveal' : '',
        ].filter(Boolean).join(' ');

        return (
            <section className={screenClass}>
                {loginExitReveal ? (
                    <div className="login-screen__market-reveal" role="status" aria-live="polite">
                        <div className="login-screen__market-reveal-card">
                            {hasSellerBranding ? (
                                <>
                                    <span className="login-screen__market-reveal-eyebrow">Acceso confirmado</span>
                                    <div className="login-screen__market-reveal-store">
                                        {sellerLogo ? (
                                            <img
                                                className="login-screen__market-reveal-store-logo"
                                                src={sellerLogo}
                                                alt=""
                                            />
                                        ) : null}
                                        <h2 className="login-screen__market-reveal-title login-screen__market-reveal-title--store">
                                            {sellerNombre}
                                        </h2>
                                    </div>
                                    <p className="login-screen__market-reveal-text">Cargando tu Seller Center…</p>
                                </>
                            ) : (
                                <>
                                    <img
                                        className="login-screen__market-reveal-logo"
                                        src="/img/logo-marketplace-megatone.png"
                                        alt="Marketplace Megatone"
                                    />
                                    <span className="login-screen__market-reveal-eyebrow">Acceso confirmado</span>
                                    <h2 className="login-screen__market-reveal-title">Marketplace Megatone</h2>
                                    <p className="login-screen__market-reveal-text">Cargando tu Seller Center…</p>
                                </>
                            )}
                            <span className="login-screen__market-reveal-bar" aria-hidden="true" />
                        </div>
                    </div>
                ) : null}
                <div className="login-screen__stage" ref={this.loginStageRef}>
                    <aside className="login-aside">
                        <div className="login-aside__watermark" aria-hidden="true">
                            <img src="/img/logo-mega-m.svg" alt="" />
                        </div>
                        <div className="login-aside__brand">
                            <img className="login-aside__mark" src="/img/logo-mega-m.svg" alt="" />
                            <span>Marketplace Megatone</span>
                        </div>
                        <div className="login-aside__body">
                            <p className="login-aside__kicker">Seller Center</p>
                            <h1 className="login-aside__title">
                                {recoverPassword ? "Recuperá el acceso." : "Operá tu tienda desde acá."}
                            </h1>
                            <p className="login-aside__lead">
                                {recoverPassword
                                    ? "Pedí una clave temporal y volvé a entrar con el mismo usuario."
                                    : "Publicaciones, órdenes, rebates y liquidaciones, con el mismo criterio del marketplace."}
                            </p>
                            <ol className="login-aside__index">
                                <li><span>01</span>Publicaciones</li>
                                <li><span>02</span>Órdenes</li>
                                <li><span>03</span>Liquidaciones</li>
                            </ol>
                        </div>
                        <p className="login-aside__foot">Acceso para sellers y equipo Megatone</p>
                    </aside>

                    <div className="login-main">
                        <div className="login-main__inner">
                            <form className="login-form" id="loginform" onSubmit={this.handleFormSubmit}>

                                <header className="login-head">
                                    <span className="login-head__eyebrow">Ingreso</span>
                                    <h2 className="login-head__title">
                                        {recoverPassword
                                            ? "Nueva contraseña"
                                            : showMfaSetup
                                                ? "Vincular autenticador"
                                                : showMfaPrompt
                                                    ? "Doble factor"
                                                    : showInputMFaHabilitado
                                                        ? "Código de verificación"
                                                        : "Entrar a la plataforma"}
                                    </h2>
                                    <p className="login-head__subtitle">
                                        {recoverPassword
                                            ? "Ingresá el correo del usuario y enviamos un acceso temporal."
                                            : showMfaSetup
                                                ? "Escaneá el código QR y validá el código de tu app."
                                                : showMfaPrompt
                                                    ? "Activá el doble factor para proteger la cuenta."
                                                    : showInputMFaHabilitado
                                                        ? "Usá el código de tu aplicación de autenticación."
                                                        : "Usuario y contraseña del Seller Center."}
                                    </p>
                                </header>

                                {!recoverPassword ?
                                    <div className="login-form__content">
                                        {/* MFA Prompt UI */}
                                        {showMfaPrompt ? (
                                            <div className="login-step">
                                                <p>Para proteger la cuenta, activá el doble factor de autenticación.</p>

                                                <button
                                                    type="button"
                                                    className="btn btn-block background-rojo-megatone w-100 mb-2"
                                                    onClick={this.handleStartMfaSetup}
                                                >
                                                    Configurar ahora
                                                </button>

                                                <a
                                                    href="/manual_mfa.html"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-outline-secondary w-100 mb-2"
                                                >
                                                    <i className="mdi mdi-help-circle-outline me-1"></i>
                                                    Ayuda para configurar
                                                </a>
                                            </div>
                                        ) : showMfaSetup ? (
                                            <div className="login-step">
                                                {codigoQR && (
                                                    <img
                                                        src={`data:image/png;base64,${codigoQR}`}
                                                        alt="QR de autenticación"
                                                        className="login-qr"
                                                    />
                                                )}
                                                <p className="small text-muted">
                                                    Usá una app como Microsoft Authenticator o Google Authenticator.
                                                </p>

                                                <input
                                                    required
                                                    name="mfaSetupCode"
                                                    type="text"
                                                    className="form-control mb-3 text-center"
                                                    placeholder="Ingresá el código de 6 dígitos"
                                                    onChange={this.handleChange}
                                                    maxLength={6}
                                                    value={mfaSetupCode}
                                                />
                                                {mfaSetupError && <small className="text-danger d-block mb-2">{mfaSetupError}</small>}

                                                <button
                                                    type="button"
                                                    className="btn btn-block background-rojo-megatone w-100"
                                                    onClick={this.handleConfirmMfaSetup}
                                                >
                                                    Confirmar
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-link w-100 mt-2"
                                                    onClick={() => this.setState({ showMfaSetup: false, showMfaPrompt: true })}
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                        ) : (
                                            // Normal Login UI
                                            <>
                                                <div className="form-group">
                                                    <div className="col-12">
                                                        <label className="login-form__label">Usuario</label>
                                                        <input
                                                            required
                                                            name="user"
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Tu usuario"
                                                            autoComplete="username"
                                                            onChange={this.handleChange}
                                                            value={this.state.user}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label className="login-form__label">Contraseña</label>
                                                    <div className="input-group">
                                                        <input
                                                            required
                                                            name="password"
                                                            type={this.state.showPassword ? "text" : "password"}
                                                            className="form-control"
                                                            placeholder="Tu contraseña"
                                                            autoComplete="current-password"
                                                            onChange={this.handleChange}
                                                            value={this.state.password}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-link"
                                                            onClick={this.togglePasswordVisibility}
                                                        >
                                                            {IconEye(this.state.showPassword)}
                                                        </button>
                                                    </div>
                                                </div>

                                                {showInputMFaHabilitado && (
                                                    <div className="form-group">
                                                        <div className="col-12">
                                                            <label className="login-form__label">Código de autenticación</label>
                                                            <input
                                                                required
                                                                name="codigoDobleAutenticacion"
                                                                type="text"
                                                                className={`form-control ${this.state.errorCodigoMfa ? "is-invalid" : ""}`}
                                                                placeholder="Ingresá el código de 6 dígitos"
                                                                onChange={this.handleChange}
                                                                maxLength={6}
                                                                value={codigoDobleAutenticacion}
                                                            />
                                                            {this.state.errorCodigoDobleAutenticacion && (
                                                                <small className="text-danger">{this.state.errorCodigoDobleAutenticacion}</small>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {this._SolveReCaptcha && Boolean(this.props.googleReCaptchaProps?.executeRecaptcha) &&
                                                    <GoogleReCaptcha
                                                        onVerify={this.handleVerifyReCaptcha}
                                                    />
                                                }

                                                <div className="form-group text-center">
                                                    {(showSpinner) ? (
                                                        <div className="login-in-progress" role="status" aria-live="polite">
                                                            <span className="login-in-progress__spinner" aria-hidden="true" />
                                                            <span className="login-in-progress__text">Ingresando</span>
                                                        </div>
                                                    ) :
                                                        <div>
                                                            <div className="d-block mt-3">
                                                                <button
                                                                    onClick={this.onLogin}
                                                                    className="btn btn-block background-rojo-megatone w-75"
                                                                    type="submit"
                                                                >
                                                                    Entrar
                                                                </button>
                                                            </div>

                                                            <div className="d-block mt-2">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => this.setState({ recoverPassword: true })}
                                                                    className="btn btn-link w-75"
                                                                >
                                                                    Recuperar contraseña
                                                                </button>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                            </>
                                        )}
                                    </div>

                                    :

                                    <div className="login-recovery-card">
                                        <div className="form-group">
                                            <div className="col-12">
                                                <label className="login-form__label">Email del usuario</label>
                                                <input
                                                    required
                                                    key="login-recovery-email"
                                                    name="email"
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Email del usuario"
                                                    autoComplete="email"
                                                    onChange={this.handleChange}
                                                    value={this.state.email}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group p-1 text-center">
                                            <div className="col-12">
                                                {showSpinner ? (
                                                    <div className="login-in-progress" role="status" aria-live="polite">
                                                        <span className="login-in-progress__text">Enviando solicitud</span>
                                                    </div>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={this.onRequestToken}
                                                        className="btn btn-block btn-large background-rojo-megatone rounded-sm"
                                                    >
                                                        Solicitar nueva contraseña
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        <div className="text-center mt-2">
                                            <button
                                                type="button"
                                                className="btn btn-link btn-sm"
                                                onClick={() => this.setState({ recoverPassword: false })}
                                            >
                                                Volver al inicio de sesión
                                            </button>
                                        </div>

                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// Wrapper para usar hooks en class component y el Provider de ReCaptcha
const LoginWithRecaptcha = withGoogleReCaptcha(Login);

const LoginWrapper = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    return <LoginWithRecaptcha {...props} navigate={navigate} location={location} />;
};

const mapStateToProps = state => ({
    userType: state.general.userType,
    userId: state.general.userId
});

// Exportar versión sin reCAPTCHA para fallback cuando no hay Provider
export const LoginBase = connect(mapStateToProps, {
    fetchTokenResetPassword,
    setAuthenticated,
    setIdSeller,
    setUserName,
    setUserCredenciales,
    setMfaStatus,
})(Login);

export default connect(mapStateToProps, {
    fetchTokenResetPassword,
    setAuthenticated,
    setIdSeller,
    setUserName,
    setUserCredenciales,
    setMfaStatus,
})(LoginWrapper);
